import { Action, createReducer, on } from '@ngrx/store';

import { BrandingState } from '../branding.model';
import { setTenant } from './branding.actions';

export const initialState = <BrandingState>{
  tenantName: 'Agrifirm',
};

const brandingReducer = createReducer(
  initialState,
  on(setTenant, (state, { tenantName }) => ({
    ...state,
    tenantName,
  })),
);

export function reducer(state: BrandingState | undefined, action: Action) {
  return brandingReducer(state, action);
}
